<template>
  <ImageHoverTile
    :url="strategyUrl"
    :bg-image-url="strategy.image_url"
    :locked="locked">
    <div class="tile-content" slot="defaultContent">
      <h2>{{ strategy.title }}</h2>
      <span
        class="resource-count"
        v-if="strategy.resource_count > 0"
      >
        <i
          class="fa fa-download"
          role="img"
          :aria-label="`${strategy.resource_count} downloads`"/>
        <span aria-hidden="true">{{ strategy.resource_count }}</span>
      </span>
      <span v-if="locked" class="label label-danger label--footer"><i class='fa fa-lock' /> PREMIUM</span>
      <small v-else :aria-label="'Learn more about ' + strategy.title">Learn more</small>
    </div>
    <div
      v-if="!locked"
      class="tile-content hover-content"
      slot="hoverContent">
      <p>
        <b>{{ strategy.title }}</b>
        <br>
        {{ description }}
      </p>
    </div>
  </ImageHoverTile>
</template>

<script>
import { mapGetters } from 'vuex'
import { wikiToPlainText } from '@/util/tokenize_wiki_text'
import ImageHoverTile from '@/components/ImageHoverTile'

export default {
  name: 'StrategyImageTile',
  components: {
    ImageHoverTile
  },
  props: {
    strategy: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('user',['isPremium']),
    description() {
      return wikiToPlainText(this.strategy.description)
    },
    strategyUrl() {
      return this.$router.resolve({
        name: 'StrategyDetailPage',
        params: {
          slugOrUuid: this.strategy.slug
        }
      }).href
    },
    locked() {
      return !this.isPremium && !this.strategy.demo
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';
.tile-content {
  padding: 16px 24px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;

  &.hover-content {
    top: 0;
  }

  h2 {
    font-weight: 500;
    font-size: 24px;
    line-height: 1.33;
    color: white;
    margin: 0;
    margin-bottom: 10px;
  }
  small,
  .resource-count {
    font-size: 14px;
    color: #e2e2e2;
    font-weight: 300;
  }
  .resource-count {
    position: absolute;
    right: 12px;
    bottom: 16px;
  }

  p {
    line-height: 24px;
    height: 100%;
    overflow: hidden;
    font-size: 16px;
    font-weight: 300;
    color: var(--gray-inverted-weak);

    b {
      color: white;
      font-weight: 600;
    }
  }
}
.lock-button {
  font-weight: bold;
  border: 0;
}
.label-danger {
  background: @label-danger-bg;
}
</style>
